import React, { Component } from 'react';
import { connect } from "react-redux";
import classnames from 'classnames';
import moment from 'moment';
import { UnmountClosed } from 'react-collapse';
import formatTime from './../utils/formatTime';
import { get } from 'lodash'
import { SHORT_SUBJECT_TYPE, SUBJECT_TYPES } from './../constants/subjectTypes';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';

import Button from './shared/Button';
import UploadButton from './shared/UploadButton';

import { myTaskAcceptFetch, myTaskCompleteFetch, myTaskUploadFetch, myTaskActionFileFetch } from './../store/myTask/actions';
import { profileFetch } from "./../store/profile/actions";

import formats from './../constants/formats';

import grid from './../styles/grid.styl';
import baseStyles from 'custom/base.styl';
import styles from 'custom/layout.styl';
import './../styles/styles.css';

const bodyNoScrollClass = baseStyles.hide_scroll;

const Format = (props) => {
  const { value } = props;
  const href = formats[value];
  if (!href) {
    return value;
  }
  return (
    <span>{value} (<a href={href} target="_blank" rel="noopener noreferrer">get template</a>)</span>
  );
};

const getUrl = file => {
  const arUrls = file.url.split('/');
  const location = file.url.split('/').splice(0, arUrls.length - 1).join('/') + '/' + encodeURIComponent(file.name);
  return location;
};

class Essay extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.togglePaper = this.togglePaper.bind(this);

    this.state = {
      isOpen: false,
      isOpenPaper: false,
      isModalOpen: false,
    }

    this.onFilesChange = this.onFilesChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onAccept = this.onAccept.bind(this);
    this.onTrackData = this.onTrackData.bind(this);
  }

  onTrackData(isStart = false) {
    const {
      userId,
      version,
      subjectType,
      task,
    } = this.props;
    const trackData = { userId, version, site_id: trackSiteId, preferredSubject: SHORT_SUBJECT_TYPE[subjectType], taskTitle: task.title }
    const profileStage = isStart ? 'test_task_start' : 'test_task_end';

    trackValues(profileStage, true, {
      context: trackData,
    });

  }

  onComplete() {
    const { finalPaperList, complete, completeLoading, loading, loadProfile } = this.props;
    if (!finalPaperList || !finalPaperList.length || completeLoading || loading) {
      return;
    }

    loadProfile().then(response => {
      if (response.data && response.data.user) {
        const { user } = response.data;
        const { profile } = user;
        const isOnVpn = profile.is_anonymous;
        if (!isOnVpn) {
          this.onTrackData();
          complete();
        }
      }
    });
  }

  toggleModal() {
    this.setState(state => ({ isModalOpen: !state.isModalOpen }));
  }

  onFilesChange(event) {
    const { upload } = this.props;
    const { target } = event;
    const fileList = target.files;
    if (!fileList.length) {
      return;
    }
    upload(fileList);
  }

  componentDidMount() {
    const { standalone } = this.props;
    !standalone && document.body.classList.add(bodyNoScrollClass);
  }

  componentWillUnmount() {
    const { standalone } = this.props;
    !standalone && document.body.classList.remove(bodyNoScrollClass);
  }

  toggle() {
    this.setState(state => Object.assign({}, state, {
      isOpen: !state.isOpen
    }));
  }

  togglePaper() {
    this.setState(state => Object.assign({}, state, {
      isOpenPaper: !state.isOpenPaper
    }));
  }

  onFileDelete(itemFile, index) {
    const { deleteFiles, finalPaperList } = this.props;

    if (!finalPaperList.length) {
      return;
    }
    itemFile.is_deleted = true;
    finalPaperList[index] = itemFile;
    deleteFiles(finalPaperList);
  }

  onAccept() {
    const { accept } = this.props;
    this.onTrackData(true)
    accept();
    this.toggleModal();
  }

  renderModal() {
    return (
      <div className={baseStyles.modal_container}>
        <div className={baseStyles.overlay} />
        <div className={classnames(baseStyles.modal_content, baseStyles.form_styles)}>
          <h1 className={classnames(baseStyles.text_success, baseStyles.title_large, baseStyles.space_bottom)}>Are you sure you are ready <br /> to start working on this task?</h1>
          <p className={classnames(baseStyles.text, baseStyles.text_middle, baseStyles.space_bottom_large, baseStyles.centered)}>Once you accept this task you will have to submit it by the deadline!</p>
          <Button block className={baseStyles.space_bottom_small} onClick={this.onAccept}>I'm ready!</Button>
          <Button block primary onClick={this.toggleModal}>Cancel</Button>
        </div>
      </div>
    );
  }

  renderDetail() {
    const { isOpen, isOpenPaper, isModalOpen } = this.state;
    const { task, standalone, loading, finalPaperList, history, dataAcept, isUSA, completeLoading, subjectType } = this.props;

    if (!task) { return null }

    const deadline = task.deadline;
    let momentDeadLine = moment();

    if (dataAcept) {
      const momentDataAcept = moment(dataAcept);
      const currentDate = moment().format('h');
      momentDeadLine = momentDataAcept.add(deadline, 'h');
      momentDeadLine.add(-currentDate).format('h');
    } else {
      momentDeadLine = momentDeadLine.add(deadline, 'h');
    }

    const hasFinalPapers = (finalPaperList && finalPaperList.length > 0) || null;
    const showFormat = subjectType === SUBJECT_TYPES.social || subjectType === SUBJECT_TYPES.humanities || subjectType === SUBJECT_TYPES.literature || subjectType === SUBJECT_TYPES.it || subjectType === SUBJECT_TYPES.business;
    const hidePrice = subjectType === SUBJECT_TYPES.literature || subjectType === SUBJECT_TYPES.humanities || subjectType === SUBJECT_TYPES.social || subjectType === SUBJECT_TYPES.math;

    // humanities: 'humanities',
    // literature: 'literature',
    // social: 'social',
    // math: 'math',

    // finance: 'finance',
    // finance_text: 'finance_text',
    // chemistry: 'chemistry',
    // environmental: 'environmental',
    // engineering: 'engineering',
    // it: 'it',
    // business: 'business',

    return (
      <div>
        <div className={classnames({ [baseStyles.order_tab]: !standalone })}>
          {!standalone && <Button empty className={baseStyles.btn_close} onClick={() => history.push('/tasks')} />}
          <h1 className={baseStyles.order_tab_title} dangerouslySetInnerHTML={{ __html: task.title }} />

          <div className={baseStyles.order_info_wrap}>
            <div className={classnames(grid.space_between, grid.row, baseStyles.space_bottom)}>
              <ul className={classnames(grid.col_8, baseStyles.order_info_left)}>
                <li>
                  <p className={baseStyles.capitalize}>{task.job_type}</p>
                  <i className={baseStyles.devider} />
                  {task.length}
                  {task.academic_level &&
                    <span>
                      <i className={baseStyles.devider} />
                      {task.academic_level}
                    </span>
                  }
                </li>
                <li>{task.subject}</li>
                {showFormat &&
                  <li><Format value={task.format} /></li>
                }
                {/* {task.sources &&
                  <li>Sources: {task.sources}</li>
                } */}
              </ul>
              <ul className={classnames(grid.col_4, baseStyles.order_info_right)}>
                <li>{formatTime(momentDeadLine, 'dt')}<span>{deadline} hours from now</span></li>
                {isUSA && !hidePrice &&
                  <li><span className={baseStyles.cost}>${(task.writer_price * 2)}.00</span></li>
                }
                {!isUSA && !hidePrice &&
                  <li><span className={baseStyles.cost}>${task.writer_price}.00</span></li>
                }
              </ul>
            </div>
          </div>

          {task.files && task.files.length > 0 &&
            <div className={baseStyles.tab_collapse}>
              <div onClick={this.toggle}>
                <i className={baseStyles.icon_file} />
                <span className={classnames(baseStyles.tab_head_name, { [baseStyles.active]: isOpen })}>Task files ({task.files.length} files)</span>
              </div>

              <UnmountClosed isOpened={isOpen}>
                <div>
                  {task.files.map((itemFile, index) => {
                    if (typeof itemFile === 'string') {
                      return (
                        <a key={index} href={itemFile} className={classnames(grid.space_between, grid.row, baseStyles.tab_collapse_row)} target="_blank" rel="noopener noreferrer">
                          <div className={classnames(grid.col_6, baseStyles.order_info_left)}>file {index + 1}</div>
                        </a>
                      )
                    } else {
                      return (
                        <a key={index} href={itemFile.link} className={classnames(grid.space_between, grid.row, baseStyles.tab_collapse_row)} target="_blank" rel="noopener noreferrer">
                          <div className={classnames(grid.col_6, baseStyles.order_info_left)}>{itemFile.name}</div>
                        </a>
                      )
                    }
                  }
                  )}
                </div>
              </UnmountClosed>
            </div>
          }


          {standalone && hasFinalPapers &&
            <div className={baseStyles.tab_collapse}>
              <div onClick={this.togglePaper}>
                <i className={baseStyles.icon_paper} />
                <span className={classnames(baseStyles.tab_head_name, { [baseStyles.active]: isOpenPaper })}>Final papers ({finalPaperList.length} files)</span>
              </div>

              <UnmountClosed isOpened={isOpenPaper} >
                <div className={classnames(grid.space_between, grid.row, baseStyles.tab_collapse_row, grid.vertical)}>
                  <div className={classnames(grid.col_6, baseStyles.order_info_left, baseStyles.cnt_files)}><b>{finalPaperList.length} files</b> uploaded</div>
                  <div className={classnames(grid.col_6, baseStyles.order_info_right)}>
                    <UploadButton disabled={loading} onChange={this.onFilesChange}>Upload more</UploadButton>
                  </div>
                </div>
                <div>
                  {finalPaperList.map((itemFile, index) =>
                    <div key={index} className={classnames(grid.space_between, grid.row, baseStyles.tab_collapse_row, grid.vertical)}>
                      <div className={classnames(grid.col_6, baseStyles.order_info_left)}>
                        <a href={getUrl(itemFile)} target="_blank" rel="noopener noreferrer">{itemFile.name}</a>
                        <i className={baseStyles.icon_delete} onClick={() => this.onFileDelete(itemFile, index)} />
                      </div>
                      <div className={classnames(grid.col_6, baseStyles.order_info_right, baseStyles.uploaded_at)}>{formatTime(itemFile.uploaded_at, 'dt')}</div>
                    </div>
                  )}
                </div>
              </UnmountClosed>
            </div>
          }

          {standalone && !hasFinalPapers &&
            <div className={classnames(grid.space_between, grid.row, grid.vertical, baseStyles.space_bottom)}>
              <p className={classnames(grid.col_8, baseStyles.text_light)}>No pictures or screenshots are acceptable. Please upload a file in the required format.</p>
              <div className={classnames(baseStyles.right, grid.col_4)}>
                <UploadButton primary disabled={loading} onChange={this.onFilesChange}>Upload final file</UploadButton>
              </div>
            </div>
          }

          <div className={classnames(baseStyles.right, baseStyles.space_bottom)}>
            {!standalone &&
              <Button onClick={this.toggleModal}>Accept</Button>
            }
            {standalone &&
              <Button success onClick={this.onComplete} disabled={!finalPaperList || !finalPaperList.length || completeLoading || loading}>Submit order</Button>
            }
          </div>

          <div className={classnames("text_essay", baseStyles.space_bottom, baseStyles.format_text)} dangerouslySetInnerHTML={{ __html: task.description }} />
        </div>
        {isModalOpen && this.renderModal()}
      </div>
    )

  }
  render() {
    return (
      <div className={styles.container}>
        {this.renderDetail()}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let finalPaperList = state.myTask.data && state.myTask.data.active_task && state.myTask.data.active_task.user_data && state.myTask.data.active_task.user_data.attachments;
  finalPaperList = finalPaperList && finalPaperList.length && finalPaperList.filter(file => file && !file.is_deleted);

  const task = ownProps.standalone
    ? state.myTask.data && state.myTask.data.active_task && state.myTask.data.active_task.task.data
    : state.tasks.data && state.tasks.data.tasks && state.tasks.data.tasks.find(taskItem => (taskItem.id === parseInt(ownProps.taskId, 10))).data;

  const dataAcept = state.myTask.data && state.myTask.data.active_task && (state.myTask.data.active_task.created_at || false);

  const loading = state.tasks.isFetchingUpdate;
  const completeLoading = state.profile.isFetching || state.myTask.isFetching;
  const profile = state.profile;
  const userId = get(profile.data, 'user.id');
  const version = get(profile.data, 'user.scenario_version');
  const subjectType = get(profile.data, 'user.profile.subject_type');

  return {
    loading,
    task,
    finalPaperList,
    error: state.tasks.error,
    dataAcept,
    completeLoading,
    userId,
    version,
    subjectType,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  accept: () => dispatch(myTaskAcceptFetch(ownProps.taskId)),
  complete: () => dispatch(myTaskCompleteFetch(ownProps.taskId)),
  upload: fileList => dispatch(myTaskUploadFetch(fileList)),
  deleteFiles: data => dispatch(myTaskActionFileFetch(data)),
  loadProfile: () => dispatch(profileFetch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Essay);



// WEBPACK FOOTER //
// ./src/components/Essay.js